import {
  string,
  shape,
  arrayOf,
  bool,
  element,
  func,
  number,
} from 'prop-types';

export const templateCardPropTypes = {
  thumbnailImage: string,
  onLoadThumbnailImage: func,
  leftPillText: string,
  rightPillText: string,
  headerComponent: element,
  footerComponent: element,
  separator: bool,
  highlight: bool,
  imageCount: number,
  onRoomImageClickHandler: func,
};

export const cardContentPropTypes = {
  leftContentComponent: element,
  rightContentComponent: element,
  bottomContentComponent: element,
};

export const singleContentCardPropTypes = {
  ...templateCardPropTypes,
  ...cardContentPropTypes,
};

export const listContentCardPropTypes = {
  ...templateCardPropTypes,
  listContentComponents: arrayOf(
    shape({
      id: string,
      ...cardContentPropTypes,
    })
  ),
};
export const templateRateCardPropTypes = {
  mainContentComponent: element,
  leftContentComponent: element,
  rightContentComponent: element,
};
